/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UINotificationMessageParameterDataTypeEnum } from './uINotificationMessageParameterDataTypeEnum';


export interface UINotificationMessageParameter { 
    data_type: UINotificationMessageParameterDataTypeEnum;
    data_value: string;
}
export namespace UINotificationMessageParameter {
}


